'use strict';

var angular = require('angular');
var dependencies = ['AVRO.FaresOptimizer.Common.AlignSaveFaresUtil', 'AVRO.FaresOptimizer.Analysis'];
module.exports = angular.module('AVRO.FaresOptimizer.Common.FaresOptimizerAdjustments', dependencies).factory('FaresOptimizerSaveAdjustmentsService', require('./services/FaresOptimizerSaveAdjustmentsService'));